export default __webpack_public_path__ + "static/media/mute.b419e4fc.svg";